import { SB } from '@play-co/replicant';
import { maxEnergy } from './inventory.ruleset';

export const inventorySchema = {
  inventory: SB.object({
    // B-points - common currency
    points: SB.number().min(0).default(0),

    // @deprecated
    gems: SB.number().min(0).default(0),

    // Current player energy
    // Max energy is 5, min is 0
    // Restored 1 energy every 30 min
    energy: SB.int().min(0).default(maxEnergy),
    // From this time we calculate energy regeneration
    energyRechargeStartTime: SB.int(),

    // Gems premium currency
    // Could be exchanged on energy and points
    // Could be purchased or given as gift
    premium: SB.object({
      // Gems for free (from invites, events, etc)
      free: SB.number().min(0).default(0),
      // Purchased for real money,we store it separately for refund cases
      // On exchange purchased premium currency should be spent first
      paid: SB.number().min(0).default(0),
    }),
  }),
};
